import Card from "@mui/material/Card";
import SoftBox from "components/SoftBox";
import DashboardLayout from "cxfcomponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "cxfcomponents/Navbars/DashboardNavbar";
import "react-toastify/dist/ReactToastify.css";

import RolesTable from "./components/Table";

function RolesAndPermissions() {
  return (
    <>
      <div style={{
        padding: "8px",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        backgroundColor: "var(--main-bg-color)"
      }}>
        <DashboardNavbar />
      </div>
      <DashboardLayout>
        <SoftBox sx={{ mt: -3.1, mb: 0 }}>
          <Card
            sx={{
              overflow: "visible",
              boxShadow: 0,
              backgroundColor: "transparent !important",
            }}
          >
            <RolesTable />
          </Card>
        </SoftBox>
      </DashboardLayout>
    </>
  );
}

export default RolesAndPermissions;
